import { Link } from "react-router";
import {
  Card,
  SectionHeader,
} from "../../components/design-system/index.js";

/**
 * /banking — Phase 8 Session 3.
 *
 * Tile-style overview that links to the three banking-hygiene
 * sub-tools. All pure-frontend (no backend dependency in v1).
 */

const TILES = [
  {
    title: "HYSA rate comparison",
    sub: "Stack your savings APY against the top high-yield options. Compute annualized opportunity cost.",
    to: "/banking/hysa",
  },
  {
    title: "CD ladder builder",
    sub: "Generate an N-rung CD ladder with equal principal per rung and per-rung term progression.",
    to: "/banking/cd-ladder",
  },
  {
    title: "I-Bonds purchase scheduler",
    sub: "Multi-year purchase plan respecting the $10k/SSN/year electronic cap. Treasury Direct deep-link.",
    to: "/banking/i-bonds",
  },
] as const;

export function BankingIndexPage() {
  return (
    <div className="mx-auto max-w-4xl p-6">
      <SectionHeader
        title="Banking hygiene"
        sub="Cash-management surface — make sure your savings, CDs, and I-Bonds are working as hard as they should."
      />
      <div className="grid gap-4 md:grid-cols-3">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className="block">
            <Card className="h-full transition-shadow hover:shadow-md">
              <h3 className="text-base font-semibold">{t.title}</h3>
              <p className="mt-1 text-sm text-[var(--color-muted)]">{t.sub}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
